import { Container, Graphics } from "pixi.js";
import { WALL, indoor } from "./common.js";

/**
 * El Coliseo Nuevo: la cancha.
 *
 * El piso lleva las líneas de juego pintadas y no baldosas, que es lo que separa un
 * recinto deportivo de cualquier otra sala grande. Las gradas del catálogo caen sobre
 * la franja de asientos del fondo: lo dibujado y lo que se pisa tienen que coincidir.
 */
export function coliseo(): Container {
  const scene = indoor({ wall: 0x2b3a47, floor: 0xc98b52, skirting: 0x1d2730 });

  // Graderío al fondo, en filas que se aclaran hacia arriba.
  const stands = new Graphics();
  for (let row = 0; row < 5; row++) {
    const y = 120 + row * 26;
    stands.rect(60, y, 840, 22).fill(row % 2 === 0 ? 0x35506b : 0x2f4661);
    for (let seat = 0; seat < 24; seat++) {
      stands.rect(72 + seat * 35, y + 4, 22, 14).fill({ color: 0x9ec9e8, alpha: 0.35 });
    }
  }
  scene.addChild(stands);

  // Marcador colgado.
  const board = new Graphics();
  board.roundRect(400, 24, 160, 76, 8).fill(0x11202b).stroke({ width: 4, color: 0x51606e });
  board.rect(420, 44, 44, 36).fill(0xe8c33c);
  board.rect(496, 44, 44, 36).fill(0xe8c33c);
  scene.addChild(board);

  // La duela: líneas de cancha sobre el piso de madera.
  const court = new Graphics();
  court.rect(60, WALL + 20, 840, 250).stroke({ width: 4, color: 0xf4f7fa, alpha: 0.7 });
  court
    .moveTo(480, WALL + 20)
    .lineTo(480, WALL + 270)
    .stroke({ width: 4, color: 0xf4f7fa, alpha: 0.7 });
  court.circle(480, WALL + 145, 70).stroke({ width: 4, color: 0xf4f7fa, alpha: 0.7 });
  court.arc(60, WALL + 145, 90, -Math.PI / 2, Math.PI / 2).stroke({ width: 4, color: 0xf4f7fa, alpha: 0.7 });
  court.arc(900, WALL + 145, 90, Math.PI / 2, -Math.PI / 2).stroke({ width: 4, color: 0xf4f7fa, alpha: 0.7 });
  scene.addChild(court);

  return scene;
}
